import React, { useEffect, useState } from 'react';
import { APP_PATH } from 'config';
import Menu from 'components/MenuPhub/components/Menu';
import { useSelector } from 'react-redux';
import { getMenuIsOpenReducer } from 'reducer/common/menuDropback';
import { EnumLayoutRouter } from 'router/enum';
import { ImenuData } from './components/Menu/type';
import MenuDropback from './components/MenuDropback';

enum EnumMenuMode {
  展開 = 'default',
  縮小 = 'condensed',
}

const MenuPhub = () => {
  const menuDropbackReducer = useSelector(getMenuIsOpenReducer);

  const [menuMode, setMenuMode] = useState(
    document.body.getAttribute('data-sidebar-size'),
  );
  const [show, setShow] = useState(false);

  /** 選單資料 */
  const menuData: ImenuData[] = [
    {
      url: '',
      text: '訂單作業',
      children: [
        { url: APP_PATH + EnumLayoutRouter.訂單下載, text: '訂單下載' },
        { url: APP_PATH + EnumLayoutRouter.驗收單下載, text: '驗收單下載' },
        { url: APP_PATH + EnumLayoutRouter.退貨單下載, text: '退貨單下載' },
      ],
    },
  ];

  const handleChangeMode = () => {
    const val =
      menuMode === EnumMenuMode.展開 ? EnumMenuMode.縮小 : EnumMenuMode.展開;
    setMenuMode(val);
    document.body.setAttribute('data-sidebar-size', val);
  };

  useEffect(() => {
    setShow(menuDropbackReducer);
  }, [menuDropbackReducer]);

  return (
    <>
      <MenuDropback _show={[show, setShow]} />
      <div className="left-side-menu">
        <p className="meun-small">主選單</p>
        <a
          href="##"
          style={{ zIndex: '0 !important' }}
          className="button-menu-mobile waves-effect waves-light d-none d-lg-inline-block"
          onClick={(e) => {
            e.preventDefault();
            handleChangeMode();
          }}
        >
          <i className="icon-menu" />
        </a>
        <div className="h-100 menuitem-active" data-simplebar="init">
          <div className="simplebar-wrapper">
            <Menu data={menuData} />
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuPhub;
